<template>
  <div
    :class="$style.helpcenterSideBarItemWrapper"
    data-testid="helpcenterSideBarItemWrapper"
  >
    <slot></slot>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.helpcenterSideBarItemWrapper {
  background-color: colors.$color-gray-50;
  border-radius: 8px;
  border: 1px solid colors.$color-gray-200;
  padding: 1rem;
}
</style>
